import type { Appointment } from '../types/appointment';

export function getAddOnsSubtotalDollars(appointment: Appointment): number {
  const list = appointment.addons;
  if (!list?.length) return 0;
  return list.reduce((sum, a) => sum + (a.priceCents || 0), 0) / 100;
}

/** Service + approved add-ons (matches backend calculateApprovedTotal for display). */
export function getAppointmentGrandTotal(appointment: Appointment): number {
  const service =
    appointment.service?.finalPrice ?? appointment.service?.originalPrice ?? 0;
  return service + getAddOnsSubtotalDollars(appointment);
}
